/**
 * Compatibility export for middleware and route helpers.
 *
 * Category ownership lives in app/category/categoryConfig.ts so category
 * behavior, directory placement, redirects, and routing stay together.
 */
export {
  ALL_CATEGORY_SLUGS,
  type CategorySlug,
} from '../../app/category/categoryConfig'
